export default "__VITE_ASSET__BQa4IGU___"